import { Outlet, Link } from "react-router-dom";

function Layout() {
  return (
    <div>
      <nav>
        {/*<ul>
          <li>
            <Link to="/">Domov</Link>
          </li>
          <li>
            <Link to="profile">Profil</Link>
          </li>
        </ul>*/}

        <Link to="/"></Link>
        <Link to="profile"></Link>
        <Link to="energetika_v_priemyselnych_vyrobach"></Link>
        <Link to="hodnotenie_ucinnosti_OZE"></Link>
        <Link to="tabulka_a_pomocky"></Link>
        <Link to="svk_na_fchapt_stuba"></Link>
        <Link to="termomechanika"></Link>
        <Link to="pouzitie_plastov"></Link>
        <Link to="pouzitie_plynov"></Link>
        <Link to="doprava_a_distribucia_plynov_1"></Link>
        <Link to="doprava_a_distribucia_plynov_2"></Link>
        <Link to="energeticke_stroje"></Link>
        <Link to="bezpecnost_v_plynarenstve"></Link>
        <Link to="plynarske_systemy_a_pouzitie_plynov"></Link>
        <Link to="zaklady_programovania"></Link>
        
      
      
      </nav>
      <hr />
     
      <Outlet />
    </div>
  );
}

export default Layout;
